import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { concatMap, catchError, map, switchMap, tap } from 'rxjs/operators';

import { ColorBusiness } from '@app/models/color-business';
import { ColorBusinessService } from '@app/services/api/color-business.service';
import { FlashService } from '@app/services/flash.service';

import {
  ColorBusinessActionTypes,
  Load,
  LoadSuccess,
  LoadFail,
  Create,
  CreateSuccess,
  CreateFail,
  AddOne,
  AddAll,
  Update,
  UpdateFail,
  UpdateSuccess,
  UpdateOne,
  Delete,
  DeleteSuccess,
  DeleteFail
} from '@core/actions/color-bussiness.actions';

@Injectable()
export class ColorBusinessEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(ColorBusinessActionTypes.Load),
    switchMap(() =>
      this.businessColorApi.get().pipe(
        map((colorBusiness: ColorBusiness[]) => new LoadSuccess(colorBusiness)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(ColorBusinessActionTypes.LoadSuccess),
    map(action => new AddAll(action.colorBusiness))
  );

  // @Effect()
  // loadOne$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadSingle>(ColorBusinessActionTypes.LoadSingle),
  //   map(action => action.id),
  //   switchMap(id => {
  //     return this.retroplanningApi.getOne(id).pipe(
  //       map(retroplannings => new LoadSingleSuccess(retroplannings)),
  //       catchError(error => of(new LoadSingleFail(error)))
  //     );
  //   })
  // );

  // @Effect()
  // LoadSingleSuccess$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadSingleSuccess>(ColorBusinessActionTypes.LoadSingleSuccess),
  //   map(action => new AddOne(action.data))
  // );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(ColorBusinessActionTypes.Create),
    switchMap(action =>
      this.businessColorApi.create(action.colorBusiness).pipe(
        map((savedColor: ColorBusiness) => new CreateSuccess(savedColor)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<CreateSuccess>(ColorBusinessActionTypes.CreateSuccess),
    map(action => {
      this.fs.emit({ type: 'success', message: 'Color Asignado' });
      this.router.navigate(['/colorBusinnes']);
      return new AddOne(action.colorBusiness);
    })
  );

  @Effect({ dispatch: false })
  createFailFail$ = this.actions$.pipe(
    ofType<CreateFail>(ColorBusinessActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: res.error.message
          ? res.error.message
          : 'No se pudo asignar el color',
        type: 'danger'
      })
    )
  );

  @Effect()
  Delete$: Observable<Action> = this.actions$.pipe(
    ofType<Delete>(ColorBusinessActionTypes.Delete),
    map(action => [action.id]),
    switchMap(([id]) => {
      return this.businessColorApi
        .delete(id)
        .pipe(map(() => new DeleteSuccess(id)));
    })
  );

  @Effect()
  DeleteSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteSuccess>(ColorBusinessActionTypes.DeleteSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Color Eliminado Correctamente'
      });
      return new Load();
    })
  );

  @Effect()
  update$: Observable<Action> = this.actions$.pipe(
    ofType<Update>(ColorBusinessActionTypes.Update),
    map(action => [action.id, action.colorBusiness]),
    switchMap(([id, colorBusiness]) => {
      return this.businessColorApi.update(id, colorBusiness).pipe(
        map(
          (businessColor: ColorBusiness) =>
            new UpdateSuccess(businessColor.id, businessColor)
        ),
        catchError(error => of(new UpdateFail(error)))
      );
    })
  );

  @Effect()
  updateSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateSuccess>(ColorBusinessActionTypes.UpdateSuccess),
    map(action => {
      this.fs.emit({
        type: 'success',
        message: 'Color actualizado exitosamente'
      });
      return new UpdateOne(action.data);
    })
    // map(action => {
    //   this.fs.emit({ type: 'fail', message: 'No se pudo actualizar'});
    //   return new UpdateFail(action.color);
    // })
  );

  @Effect({ dispatch: false })
  updateFail$ = this.actions$.pipe(
    ofType<UpdateFail>(ColorBusinessActionTypes.UpdateFail),
    map(action => action.error),
    tap(res => {
      this.fs.emit({
        message: res.error.message
          ? res.error.message
          : 'No es posible actualizar',
        type: 'danger'
      });
      return res.error;
    })
  );

  constructor(
    private actions$: Actions,
    private businessColorApi: ColorBusinessService,
    private fs: FlashService,
    private router: Router
  ) {}
}
